module.exports = __webpack_public_path__ + "img/1.2c33bd46.png";